interface CountryData {
  name: string
  countryCode: string
  text: string
  value: string
}

export const COUNTRY_CODES = {
  BD: "880",
  BE: "32",
  BF: "226",
  BG: "359",
  BA: "387",
  BB: "1-246",
  WF: "681",
  BL: "590",
  BM: "1-441",
  BN: "673",
  BO: "591",
  BH: "973",
  BI: "257",
  BJ: "229",
  BT: "975",
  JM: "1-876",
  BV: "",
  BW: "267",
  WS: "685",
  BQ: "599",
  BR: "55",
  BS: "1-242",
  JE: "44-1534",
  BY: "375",
  BZ: "501",
  RU: "7",
  RW: "250",
  RS: "381",
  TL: "670",
  RE: "262",
  TM: "993",
  TJ: "992",
  RO: "40",
  TK: "690",
  GW: "245",
  GU: "1-671",
  GT: "502",
  GS: "",
  GR: "30",
  GQ: "240",
  GP: "590",
  JP: "81",
  GY: "592",
  GG: "44-1481",
  GF: "594",
  GE: "995",
  GD: "1-473",
  GB: "44",
  GA: "241",
  SV: "503",
  GN: "224",
  GM: "220",
  GL: "299",
  GI: "350",
  GH: "233",
  OM: "968",
  TN: "216",
  JO: "962",
  HR: "385",
  HT: "509",
  HU: "36",
  HK: "852",
  HN: "504",
  HM: " ",
  VE: "58",
  PR: "1",
  PS: "970",
  PW: "680",
  PT: "351",
  SJ: "47",
  PY: "595",
  IQ: "964",
  PA: "507",
  PF: "689",
  PG: "675",
  PE: "51",
  PK: "92",
  PH: "63",
  PN: "870",
  PL: "48",
  PM: "508",
  ZM: "260",
  EH: "212",
  EE: "372",
  EG: "20",
  ZA: "27",
  EC: "593",
  IT: "39",
  VN: "84",
  SB: "677",
  ET: "251",
  SO: "252",
  ZW: "263",
  SA: "966",
  ES: "34",
  ER: "291",
  ME: "382",
  MD: "373",
  MG: "261",
  MF: "590",
  MA: "212",
  MC: "377",
  UZ: "998",
  MM: "95",
  ML: "223",
  MO: "853",
  MN: "976",
  MH: "692",
  MK: "389",
  MU: "230",
  MT: "356",
  MW: "265",
  MV: "960",
  MQ: "596",
  MP: "1-670",
  MS: "1-664",
  MR: "222",
  IM: "44-1624",
  UG: "256",
  TZ: "255",
  MY: "60",
  MX: "52",
  IL: "972",
  FR: "33",
  IO: "246",
  SH: "290",
  FI: "358",
  FJ: "679",
  FK: "500",
  FM: "691",
  FO: "298",
  NI: "505",
  NL: "31",
  NO: "47",
  NA: "264",
  VU: "678",
  NC: "687",
  NE: "227",
  NF: "672",
  NG: "234",
  NZ: "64",
  NP: "977",
  NR: "674",
  NU: "683",
  CK: "682",
  XK: "",
  CI: "225",
  CH: "41",
  CO: "57",
  CN: "86",
  CM: "237",
  CL: "56",
  CC: "61",
  CA: "1",
  CG: "242",
  CF: "236",
  CD: "243",
  CZ: "420",
  CY: "357",
  CX: "61",
  CR: "506",
  CW: "599",
  CV: "238",
  CU: "53",
  SZ: "268",
  SY: "963",
  SX: "599",
  KG: "996",
  KE: "254",
  SS: "211",
  SR: "597",
  KI: "686",
  KH: "855",
  KN: "1-869",
  KM: "269",
  ST: "239",
  SK: "421",
  KR: "82",
  SI: "386",
  KP: "850",
  KW: "965",
  SN: "221",
  SM: "378",
  SL: "232",
  SC: "248",
  KZ: "7",
  KY: "1-345",
  SG: "65",
  SE: "46",
  SD: "249",
  DO: "1",
  DM: "1-767",
  DJ: "253",
  DK: "45",
  VG: "1-284",
  DE: "49",
  YE: "967",
  DZ: "213",
  US: "1",
  UY: "598",
  YT: "262",
  UM: "1",
  LB: "961",
  LC: "1-758",
  LA: "856",
  TV: "688",
  TW: "886",
  TT: "1-868",
  TR: "90",
  LK: "94",
  LI: "423",
  LV: "371",
  TO: "676",
  LT: "370",
  LU: "352",
  LR: "231",
  LS: "266",
  TH: "66",
  TF: "",
  TG: "228",
  TD: "235",
  TC: "1-649",
  LY: "218",
  VA: "379",
  VC: "1-784",
  AE: "971",
  AD: "376",
  AG: "1-268",
  AF: "93",
  AI: "1-264",
  VI: "1-340",
  IS: "354",
  IR: "98",
  AM: "374",
  AL: "355",
  AO: "244",
  AQ: "",
  AS: "1-684",
  AR: "54",
  AU: "61",
  AT: "43",
  AW: "297",
  IN: "91",
  AX: "358-18",
  AZ: "994",
  IE: "353",
  ID: "62",
  UA: "380",
  QA: "974",
  MZ: "258",
}

export const COUNTRIES: CountryData[] = [
  {
    name: "United States",
    countryCode: "1",
    text: "🇺🇸  + 1",
    value: "us",
  },
  {
    name: "Afghanistan (‫افغانستان‬‎)",
    countryCode: "93",
    text: "🇦🇫 + 93",
    value: "af",
  },
  {
    name: "Åland Islands",
    countryCode: "358",
    text: "🇦🇽  + 358",
    value: "ax",
  },
  {
    name: "Albania (Shqipëri)",
    countryCode: "355",
    text: "🇦🇱  + 355",
    value: "al",
  },
  {
    name: "Algeria (‫الجزائر‬‎)",
    countryCode: "213",
    value: "dz",
    text: "🇩🇿  + 213",
  },
  {
    name: "American Samoa",
    countryCode: "1684",
    text: "🇦🇸  + 1684",
    value: "as",
  },
  {
    name: "Andorra",
    countryCode: "376",
    value: "ad",
    text: "🇦🇩  + 376",
  },
  {
    name: "Angola",
    countryCode: "244",
    value: "ao",
    text: "🇦🇴   + 244",
  },
  {
    name: "Anguilla",
    value: "ai",
    countryCode: "1264",
    text: "🇦🇮  + 1264",
  },
  {
    name: "Antigua and Barbuda",
    value: "ag",
    countryCode: "1268",
    text: "🇦🇬  + 1268",
  },
  {
    name: "Argentina",
    countryCode: "54",
    value: "ar",
    text: "🇦🇷  + 54",
  },
  {
    name: "Armenia (Հայաստան)",
    countryCode: "374",
    value: "am",
    text: "🇦🇲  + 374",
  },
  {
    name: "Aruba",
    countryCode: "297",
    value: "aw",
    text: "🇦🇼  + 297",
  },
  {
    name: "Australia",
    value: "au",
    countryCode: "61",
    text: "🇦🇺  + 61",
  },
  {
    value: "at",
    name: "Austria (Österreich)",
    countryCode: "43",
    text: "🇦🇹  + 43",
  },
  {
    name: "Azerbaijan (Azərbaycan)",
    value: "az",
    countryCode: "994",
    text: "🇦🇿  + 994",
  },
  {
    name: "Bahamas",
    countryCode: "1242",
    value: "bs",
    text: "🇧🇸 + 1242",
  },
  {
    name: "Bahrain (‫البحرين‬‎)",
    countryCode: "973",
    value: "bh",
    text: "🇧🇭 + 973",
  },
  {
    name: "Bangladesh (বাংলাদেশ)",
    countryCode: "880",
    value: "bd",
    text: "🇧🇩 + 880",
  },
  {
    name: "Barbados",
    countryCode: "1246",
    text: "🇧🇧 + 1246",
    value: "bb",
  },
  {
    name: "Belarus (Беларусь)",
    countryCode: "375",
    value: "by",
    text: "🇧🇾 + 375",
  },
  {
    name: "Belgium (België)",
    countryCode: "32",
    value: "be",
    text: "🇧🇪 + 32",
  },
  {
    name: "Belize",
    countryCode: "501",
    text: "🇧🇿 + 501",
    value: "bz",
  },
  {
    name: "Benin (Bénin)",
    countryCode: "229",
    text: "🇧🇯  + 229",
    value: "bj",
  },
  {
    name: "Bermuda",
    countryCode: "1441",
    value: "bm",
    text: "🇧🇲 + 1441",
  },
  {
    name: "Bhutan (འབྲུག)",
    countryCode: "975",
    value: "bt",
    text: "🇧🇹 + 975",
  },
  {
    name: "Bolivia",
    countryCode: "591",
    value: "bo",
    text: "🇧🇴 + 591",
  },
  {
    name: "Bosnia and Herzegovina (Босна и Херцеговина)",
    countryCode: "387",
    value: "ba",
    text: "🇧🇦 + 387",
  },
  {
    name: "Botswana",
    countryCode: "267",
    value: "bw",
    text: "🇧🇼 + 267",
  },
  {
    name: "Brazil (Brasil)",
    countryCode: "55",
    value: "br",
    text: "🇧🇷 + 55",
  },
  {
    name: "British Indian Ocean Territory",
    countryCode: "246",
    value: "io",
    text: "🇮🇴 + 246",
  },
  {
    name: "British Virgin Islands",
    countryCode: "1284",
    value: "vg",
    text: "🇻🇬 + 1284",
  },
  {
    name: "Brunei",
    countryCode: "673",
    value: "bn",
    text: "🇧🇳 + 673",
  },
  {
    name: "Bulgaria (България)",
    countryCode: "359",
    value: "bg",
    text: "🇧🇬 + 359",
  },
  {
    name: "Burkina Faso",
    value: "bf",
    countryCode: "226",
    text: "🇧🇫 + 226",
  },
  {
    name: "Burundi (Uburundi)",
    value: "bi",
    countryCode: "257",
    text: "🇧🇮 + 257",
  },
  {
    name: "Cambodia (កម្ពុជា)",
    value: "kh",
    countryCode: "855",
    text: "🇰🇭 + 855",
  },
  {
    name: "Cameroon (Cameroun)",
    countryCode: "237",
    value: "cm",
    text: "🇨🇲 + 237",
  },
  {
    name: "Canada",
    value: "ca",
    countryCode: "1",
    text: "🇨🇦 + 1",
  },
  {
    name: "Cape Verde (Kabu Verdi)",
    countryCode: "238",
    value: "cv",
    text: "🇨🇻 + 238",
  },
  {
    name: "Caribbean Netherlands",
    value: "bq",
    text: "🇧🇶 + 599",
    countryCode: "599",
  },
  {
    name: "Cayman Islands",
    value: "ky",
    countryCode: "1345",
    text: "🇰🇾 + 1345",
  },
  {
    name: "Central African Republic (République centrafricaine)",
    countryCode: "236",
    text: "🇨🇫 + 236",
    value: "cf",
  },
  {
    name: "Chad (Tchad)",
    countryCode: "235",
    text: "🇹🇩 + 235",
    value: "td",
  },
  {
    name: "Chile",
    countryCode: "56",
    text: "🇨🇱 + 56",
    value: "cl",
  },
  {
    name: "China (中国)",
    countryCode: "86",
    value: "cn",
    text: "🇨🇳 + 86",
  },
  {
    name: "Christmas Island",
    countryCode: "61",
    text: "🇨🇽 + 61",
    value: "cx",
  },
  {
    name: "Cocos (Keeling) Islands",
    countryCode: "61",
    value: "cc",
    text: "🇨🇨 + 61",
  },
  {
    name: "Colombia",
    countryCode: "57",
    value: "co",
    text: "🇨🇴 + 57",
  },
  {
    name: "Comoros (‫جزر القمر‬‎)",
    countryCode: "269",
    value: "km",
    text: "🇰🇲 + 269",
  },
  {
    name: "Congo (DRC) (Jamhuri ya Kidemokrasia ya Kongo)",
    countryCode: "243",
    value: "cd",
    text: "🇨🇩 + 243",
  },
  {
    name: "Congo (Republic) (Congo-Brazzaville)",
    value: "cg",
    countryCode: "242",
    text: "🇨🇬 + 242",
  },
  {
    name: "Cook Islands",
    countryCode: "682",
    value: "ck",
    text: "🇨🇰 + 682",
  },
  {
    name: "Costa Rica",
    countryCode: "506",
    value: "cr",
    text: "🇨🇷 + 506",
  },
  {
    name: "Côte d’Ivoire",
    countryCode: "225",
    value: "ci",
    text: "🇨🇮 + 225",
  },
  {
    name: "Croatia (Hrvatska)",
    countryCode: "385",
    value: "hr",
    text: "🇭🇷 + 385",
  },
  {
    name: "Cuba",
    countryCode: "53",
    value: "cu",
    text: "🇨🇺 + 53",
  },
  {
    name: "Curaçao",
    countryCode: "599",
    value: "cw",
    text: "🇨🇼 + 599",
  },
  {
    name: "Cyprus (Κύπρος)",
    countryCode: "357",
    value: "cy",
    text: "🇨🇾 + 357",
  },
  {
    name: "Czech Republic (Česká republika)",
    countryCode: "420",
    value: "cz",
    text: "🇨🇿 + 420",
  },
  {
    name: "Denmark (Danmark)",
    value: "dk",
    countryCode: "45",
    text: "🇩🇰 + 45",
  },
  {
    name: "Djibouti",
    value: "dj",
    countryCode: "253",
    text: "🇩🇯 + 253",
  },
  {
    name: "Dominica",
    value: "dm",
    countryCode: "1767",
    text: "🇩🇲 + 1767",
  },
  {
    name: "Dominican Republic (República Dominicana)",
    countryCode: "1",
    value: "do",
    text: "🇩🇴 + 1",
  },
  {
    name: "Ecuador",
    value: "ec",
    countryCode: "593",
    text: "🇪🇨 + 593",
  },
  {
    name: "Egypt (‫مصر‬‎)",
    countryCode: "20",
    value: "eg",
    text: "🇪🇬 + 20",
  },
  {
    name: "El Salvador",
    countryCode: "503",
    value: "sv",
    text: "🇸🇻 + 503",
  },
  {
    name: "Equatorial Guinea (Guinea Ecuatorial)",
    countryCode: "240",
    value: "gq",
    text: "🇬🇶 + 240",
  },
  {
    name: "Eritrea",
    countryCode: "291",
    value: "er",
    text: "🇪🇷 + 291",
  },
  {
    name: "Estonia (Eesti)",
    value: "ee",
    countryCode: "372",
    text: "🇪🇪 + 372",
  },
  {
    name: "Ethiopia",
    value: "et",
    countryCode: "251",
    text: "🇪🇹 + 251",
  },
  {
    name: "Falkland Islands (Islas Malvinas)",
    value: "fk",
    countryCode: "500",
    text: "🇫🇰 + 500",
  },
  {
    name: "Faroe Islands (Føroyar)",
    value: "fo",
    countryCode: "298",
    text: "🇫🇴 + 298",
  },
  {
    name: "Fiji",
    value: "fj",
    countryCode: "679",
    text: "🇫🇯 + 679",
  },
  {
    name: "Finland (Suomi)",
    countryCode: "358",
    value: "fi",
    text: "🇫🇮 + 358",
  },
  {
    name: "France",
    countryCode: "33",
    value: "fr",
    text: "🇫🇷 + 33",
  },
  {
    name: "French Guiana (Guyane française)",
    value: "gf",
    countryCode: "594",
    text: "🇬🇫 + 594",
  },
  {
    name: "French Polynesia (Polynésie française)",
    value: "pf",
    countryCode: "689",
    text: "🇵🇫 + 689",
  },
  {
    name: "Gabon",
    value: "ga",
    countryCode: "241",
    text: "🇬🇦 + 241",
  },
  {
    name: "Gambia",
    value: "gm",
    countryCode: "220",
    text: "🇬🇲 + 220",
  },
  {
    name: "Georgia (საქართველო)",
    countryCode: "995",
    value: "ge",
    text: "🇬🇪 + 995",
  },
  {
    name: "Germany (Deutschland)",
    countryCode: "49",
    value: "de",
    text: "🇩🇪 + 49",
  },
  {
    name: "Ghana (Gaana)",
    countryCode: "233",
    value: "gh",
    text: "🇬🇭 + 233",
  },
  {
    name: "Gibraltar",
    countryCode: "350",
    value: "gi",
    text: "🇬🇮 + 350",
  },
  {
    name: "Greece (Ελλάδα)",
    countryCode: "30",
    value: "gr",
    text: "🇬🇷 + 30",
  },
  {
    name: "Greenland (Kalaallit Nunaat)",
    countryCode: "299",
    value: "gl",
    text: "🇬🇱 + 299",
  },
  {
    name: "Grenada",
    value: "gd",
    countryCode: "1473",
    text: "🇬🇩 + 1473",
  },
  {
    name: "Guadeloupe",
    value: "gp",
    countryCode: "590",
    text: "🇬🇵 + 590",
  },
  {
    name: "Guam",
    countryCode: "1671",
    value: "gu",
    text: "🇬🇺 + 1671",
  },
  {
    name: "Guatemala",
    value: "gt",
    countryCode: "502",
    text: "🇬🇹 + 502",
  },
  {
    name: "Guernsey",
    countryCode: "44",
    value: "gg",
    text: "🇬🇬 + 44",
  },
  {
    name: "Guinea (Guinée)",
    countryCode: "224",
    value: "gn",
    text: "🇬🇳 + 224",
  },
  {
    name: "Guinea-Bissau (Guiné Bissau)",
    value: "gw",
    countryCode: "245",
    text: "🇬🇼 + 245",
  },
  {
    name: "Guyana",
    countryCode: "592",
    value: "gy",
    text: "🇬🇾 + 592",
  },
  {
    name: "Haiti",
    value: "ht",
    countryCode: "509",
    text: "🇭🇹 + 509",
  },
  {
    name: "Honduras",
    value: "hn",
    countryCode: "504",
    text: "🇭🇳 + 504",
  },
  {
    name: "Hong Kong (香港)",
    value: "hk",
    countryCode: "852",
    text: "🇭🇰 + 852",
  },
  {
    name: "Hungary (Magyarország)",
    value: "hu",
    countryCode: "36",
    text: "🇭🇺 + 36",
  },
  {
    name: "Iceland (Ísland)",
    value: "is",
    countryCode: "354",
    text: "🇮🇸 + 354",
  },
  {
    name: "India (भारत)",
    countryCode: "91",
    value: "in",
    text: "🇮🇳 + 91",
  },
  {
    name: "Indonesia",
    countryCode: "62",
    value: "id",
    text: "🇮🇩 + 62",
  },
  {
    name: "Iran (‫ایران‬‎)",
    countryCode: "98",
    value: "ir",
    text: "🇮🇷 + 98",
  },
  {
    name: "Iraq (‫العراق‬‎)",
    value: "iq",
    countryCode: "964",
    text: "🇮🇶 + 964",
  },
  {
    name: "Ireland",
    value: "ie",
    countryCode: "353",
    text: "🇮🇪 + 353",
  },
  {
    name: "Isle of Man",
    countryCode: "44",
    value: "im",
    text: "🇮🇲 + 44",
  },
  {
    name: "Israel (‫ישראל‬‎)",
    countryCode: "972",
    value: "il",
    text: "🇮🇱 + 972",
  },
  {
    name: "Italy (Italia)",
    value: "it",
    countryCode: "39",
    text: "🇮🇹 + 39",
  },
  {
    name: "Jamaica",
    value: "jm",
    countryCode: "1876",
    text: "🇯🇲 + 1876",
  },
  {
    name: "Japan (日本)",
    value: "jp",
    countryCode: "81",
    text: "🇯🇵 + 81",
  },
  {
    name: "Jersey",
    countryCode: "44",
    value: "je",
    text: "🇯🇪 + 44",
  },
  {
    name: "Jordan (‫الأردن‬‎)",
    countryCode: "962",
    value: "jo",
    text: "🇯🇴 + 962",
  },
  {
    name: "Kazakhstan (Казахстан)",
    value: "kz",
    countryCode: "77",
    text: "🇰🇿 + 77",
  },
  {
    name: "Kenya",
    countryCode: "254",
    value: "ke",
    text: "🇰🇪 + 254",
  },
  {
    name: "Kiribati",
    value: "ki",
    countryCode: "686",
    text: "🇰🇮 + 686",
  },
  {
    name: "Kuwait (‫الكويت‬‎)",
    countryCode: "965",
    value: "kw",
    text: "🇰🇼 + 965",
  },
  {
    name: "Kyrgyzstan (Кыргызстан)",
    value: "kg",
    countryCode: "996",
    text: "🇰🇬 + 996",
  },
  {
    name: "Laos (ລາວ)",
    value: "la",
    countryCode: "856",
    text: "🇱🇦 + 856",
  },
  {
    name: "Latvia (Latvija)",
    countryCode: "371",
    value: "lv",
    text: "🇱🇻 + 371",
  },
  {
    name: "Lebanon (‫لبنان‬‎)",
    value: "lb",
    countryCode: "961",
    text: "🇱🇧 + 961",
  },
  {
    name: "Lesotho",
    value: "ls",
    countryCode: "266",
    text: "🇱🇸 + 266",
  },
  {
    name: "Liberia",
    value: "lr",
    countryCode: "231",
    text: "🇱🇷 + 231",
  },
  {
    name: "Libya (‫ليبيا‬‎)",
    countryCode: "218",
    value: "ly",
    text: "🇱🇾 + 218",
  },
  {
    name: "Liechtenstein",
    countryCode: "423",
    value: "li",
    text: "🇱🇮 + 423",
  },
  {
    name: "Lithuania (Lietuva)",
    countryCode: "370",
    value: "lt",
    text: "🇱🇹 + 370",
  },
  {
    name: "Luxembourg",
    value: "lu",
    countryCode: "352",
    text: "🇱🇺 + 352",
  },
  {
    name: "Macau (澳門)",
    countryCode: "853",
    value: "mo",
    text: "🇲🇴 + 853",
  },
  {
    name: "Macedonia (FYROM) (Македонија)",
    value: "mk",
    countryCode: "389",
    text: "🇲🇰 + 389",
  },
  {
    name: "Madagascar (Madagasikara)",
    value: "mg",
    countryCode: "261",
    text: "🇲🇬 + 261",
  },
  {
    name: "Malawi",
    countryCode: "265",
    value: "mw",
    text: "🇲🇼 + 265",
  },
  {
    name: "Malaysia",
    countryCode: "60",
    value: "my",
    text: "🇲🇾 + 60",
  },
  {
    name: "Maldives",
    value: "mv",
    countryCode: "960",
    text: "🇲🇻 + 960",
  },
  {
    name: "Mali",
    value: "ml",
    countryCode: "223",
    text: "🇲🇱 + 223",
  },
  {
    name: "Malta",
    countryCode: "356",
    value: "mt",
    text: "🇲🇹 + 356",
  },
  {
    name: "Marshall Islands",
    countryCode: "692",
    value: "mh",
    text: "🇲🇭 + 692",
  },
  {
    name: "Martinique",
    countryCode: "596",
    value: "mq",
    text: "🇲🇶 + 596",
  },
  {
    name: "Mauritania (‫موريتانيا‬‎)",
    countryCode: "222",
    value: "mr",
    text: "🇲🇷 + 222",
  },
  {
    name: "Mauritius (Moris)",
    value: "mu",
    countryCode: "230",
    text: "🇲🇺 + 230",
  },
  {
    name: "Mayotte",
    countryCode: "262",
    value: "yt",
    text: "🇾🇹 + 262",
  },
  {
    name: "Mexico (México)",
    value: "mx",
    countryCode: "52",
    text: "🇲🇽 + 52",
  },
  {
    name: "Micronesia",
    countryCode: "691",
    value: "fm",
    text: "🇫🇲 + 691",
  },
  {
    name: "Moldova (Republica Moldova)",
    countryCode: "373",
    value: "md",
    text: "🇲🇩 + 373",
  },
  {
    name: "Monaco",
    countryCode: "377",
    value: "mc",
    text: "🇲🇨 + 377",
  },
  {
    name: "Mongolia (Монгол)",
    value: "mn",
    countryCode: "976",
    text: "🇲🇳 + 976",
  },
  {
    name: "Montenegro (Crna Gora)",
    value: "me",
    countryCode: "382",
    text: "🇲🇪 + 382",
  },
  {
    name: "Montserrat",
    value: "ms",
    countryCode: "1664",
    text: "🇲🇸 + 1664",
  },
  {
    name: "Morocco (‫المغرب‬‎)",
    countryCode: "212",
    value: "ma",
    text: "🇲🇦 + 212",
  },
  {
    name: "Mozambique (Moçambique)",
    countryCode: "258",
    value: "mz",
    text: "🇲🇿 + 258",
  },
  {
    name: "Myanmar (Burma)",
    value: "mm",
    countryCode: "95",
    text: "🇲🇲 + 95",
  },
  {
    name: "Namibia (Namibië)",
    countryCode: "264",
    value: "na",
    text: "🇳🇦 + 264",
  },
  {
    name: "Nauru",
    value: "nr",
    countryCode: "674",
    text: "🇳🇷 + 674",
  },
  {
    name: "Nepal (नेपाल)",
    value: "np",
    countryCode: "977",
    text: "🇳🇵 + 977",
  },
  {
    name: "Netherlands (Nederland)",
    value: "nl",
    countryCode: "31",
    text: "🇳🇱 + 31",
  },
  {
    name: "New Caledonia (Nouvelle-Calédonie)",
    value: "nc",
    countryCode: "687",
    text: "🇳🇨 + 687",
  },
  {
    name: "New Zealand",
    countryCode: "64",
    value: "nz",
    text: "🇳🇿 + 64",
  },
  {
    name: "Nicaragua",
    value: "ni",
    countryCode: "505",
    text: "🇳🇮 + 505",
  },
  {
    name: "Niger (Nijar)",
    value: "ne",
    countryCode: "227",
    text: "🇳🇪 + 227",
  },
  {
    name: "Nigeria",
    countryCode: "234",
    value: "ng",
    text: "🇳🇬 + 234",
  },
  {
    name: "Niue",
    countryCode: "683",
    value: "nu",
    text: "🇳🇺 + 683",
  },
  {
    name: "Norfolk Island",
    value: "nf",
    countryCode: "672",
    text: "🇳🇫 + 672",
  },
  {
    name: "North Korea (조선 민주주의 인민 공화국)",
    countryCode: "850",
    value: "kp",
    text: "🇰🇵 + 850",
  },
  {
    name: "Northern Mariana Islands",
    value: "mp",
    countryCode: "1670",
    text: "🇲🇵 + 1670",
  },
  {
    name: "Norway (Norge)",
    value: "no",
    countryCode: "47",
    text: "🇳🇴 + 47",
  },
  {
    name: "Oman (‫عُمان‬‎)",
    countryCode: "968",
    value: "om",
    text: "🇴🇲 + 968",
  },
  {
    name: "Pakistan (‫پاکستان‬‎)",
    value: "pk",
    countryCode: "92",
    text: "🇵🇰 + 92",
  },
  {
    name: "Palau",
    value: "pw",
    countryCode: "680",
    text: "🇵🇼 + 680",
  },
  {
    name: "Palestine (‫فلسطين‬‎)",
    value: "ps",
    countryCode: "970",
    text: "🇵🇸 + 970",
  },
  {
    name: "Panama (Panamá)",
    countryCode: "507",
    value: "pa",
    text: "🇵🇦 + 507",
  },
  {
    name: "Papua New Guinea",
    value: "pg",
    countryCode: "675",
    text: "🇵🇬 + 675",
  },
  {
    name: "Paraguay",
    value: "py",
    countryCode: "595",
    text: "🇵🇾 + 595",
  },
  {
    name: "Peru (Perú)",
    countryCode: "51",
    value: "pe",
    text: "🇵🇪 + 51",
  },
  {
    name: "Philippines",
    countryCode: "63",
    value: "ph",
    text: "🇵🇭 + 63",
  },
  {
    name: "Poland (Polska)",
    countryCode: "48",
    value: "pl",
    text: "🇵🇱 + 48",
  },
  {
    name: "Portugal",
    value: "pt",
    countryCode: "351",
    text: "🇵🇹 + 351",
  },
  {
    name: "Puerto Rico",
    countryCode: "1",
    value: "pr",
    text: "🇵🇷 + 1",
  },
  {
    name: "Qatar (‫قطر‬‎)",
    countryCode: "974",
    value: "qa",
    text: "🇶🇦 + 974",
  },
  {
    name: "Réunion (La Réunion)",
    countryCode: "262",
    value: "re",
    text: "🇷🇪 + 262",
  },
  {
    name: "Romania (România)",
    value: "ro",
    countryCode: "40",
    text: "🇷🇴 + 40",
  },
  {
    name: "Russia (Россия)",
    countryCode: "7",
    value: "ru",
    text: "🇷🇺 + 7",
  },
  {
    name: "Rwanda",
    countryCode: "250",
    value: "rw",
    text: "🇷🇼 + 250",
  },
  {
    name: "Saint Barthélemy (Saint-Barthélemy)",
    value: "bl",
    countryCode: "590",
    text: "🇧🇱 + 590",
  },
  {
    name: "Saint Helena",
    value: "sh",
    countryCode: "290",
    text: "🇸🇭 + 290",
  },
  {
    name: "Saint Kitts and Nevis",
    value: "kn",
    countryCode: "1869",
    text: "🇰🇳 + 1869",
  },
  {
    name: "Saint Lucia",
    countryCode: "1758",
    value: "lc",
    text: "🇱🇨 + 1758",
  },
  {
    name: "Saint Martin (Saint-Martin (partie française))",
    countryCode: "590",
    value: "mf",
    text: "🇲🇫 + 590",
  },
  {
    name: "Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)",
    value: "pm",
    countryCode: "508",
    text: "🇵🇲 + 508",
  },
  {
    name: "Saint Vincent and the Grenadines",
    countryCode: "1784",
    value: "vc",
    text: "🇻🇨 + 1784",
  },
  {
    name: "Samoa",
    countryCode: "685",
    value: "ws",
    text: "🇼🇸 + 685",
  },
  {
    name: "San Marino",
    countryCode: "378",
    value: "sm",
    text: "🇸🇲 + 378",
  },
  {
    name: "São Tomé and Príncipe (São Tomé e Príncipe)",
    countryCode: "239",
    value: "st",
    text: "🇸🇹 + 239",
  },
  {
    name: "Saudi Arabia (‫المملكة العربية السعودية‬‎)",
    countryCode: "966",
    value: "sa",
    text: "🇸🇦 + 966",
  },
  {
    name: "Senegal (Sénégal)",
    value: "sn",
    countryCode: "221",
    text: "🇸🇳 + 221",
  },
  {
    name: "Serbia (Србија)",
    value: "rs",
    countryCode: "381",
    text: "🇷🇸 + 381",
  },
  {
    name: "Seychelles",
    countryCode: "248",
    value: "sc",
    text: "🇸🇨 + 248",
  },
  {
    name: "Sierra Leone",
    countryCode: "232",
    value: "sl",
    text: "🇸🇱 + 232",
  },
  {
    name: "Singapore",
    value: "sg",
    countryCode: "65",
    text: "🇸🇬 + 65",
  },
  {
    name: "Sint Maarten",
    countryCode: "1721",
    value: "sx",
    text: "🇸🇽 + 1721",
  },
  {
    name: "Slovakia (Slovensko)",
    value: "sk",
    countryCode: "421",
    text: "🇸🇰 + 421",
  },
  {
    name: "Slovenia (Slovenija)",
    value: "si",
    countryCode: "386",
    text: "🇸🇮 + 386",
  },
  {
    name: "Solomon Islands",
    value: "sb",
    countryCode: "677",
    text: "🇸🇧 + 677",
  },
  {
    name: "Somalia (Soomaaliya)",
    countryCode: "252",
    value: "so",
    text: "🇸🇴 + 252",
  },
  {
    name: "South Africa",
    value: "za",
    countryCode: "27",
    text: "🇿🇦 + 27",
  },
  {
    name: "South Korea (대한민국)",
    countryCode: "82",
    value: "kr",
    text: "🇰🇷 + 82",
  },
  {
    name: "South Sudan (‫جنوب السودان‬‎)",
    value: "ss",
    countryCode: "211",
    text: "🇸🇸 + 211",
  },
  {
    name: "Spain (España)",
    countryCode: "34",
    value: "es",
    text: "🇪🇸 + 34",
  },
  {
    name: "Sri Lanka (ශ්‍රී ලංකාව)",
    countryCode: "94",
    value: "lk",
    text: "🇱🇰 + 94",
  },
  {
    name: "Sudan (‫السودان‬‎)",
    value: "sd",
    countryCode: "249",
    text: "🇸🇩 + 249",
  },
  {
    name: "Suriname",
    value: "sr",
    countryCode: "597",
    text: "🇸🇷 + 597",
  },
  {
    name: "Svalbard and Jan Mayen",
    countryCode: "47",
    value: "sj",
    text: "🇸🇯 + 47",
  },
  {
    name: "Swaziland",
    value: "sz",
    countryCode: "268",
    text: "🇸🇿 + 268",
  },
  {
    name: "Sweden (Sverige)",
    countryCode: "46",
    value: "se",
    text: "🇸🇪 + 46",
  },
  {
    name: "Switzerland (Schweiz)",
    countryCode: "41",
    value: "ch",
    text: "🇨🇭 + 41",
  },
  {
    name: "Syria (‫سوريا‬‎)",
    countryCode: "963",
    text: "🇸🇾 + 963",
    value: "sy",
  },
  {
    name: "Taiwan (台灣)",
    value: "tw",
    countryCode: "886",
    text: "🇹🇼 + 886",
  },
  {
    name: "Tajikistan",
    value: "tj",
    countryCode: "992",
    text: "🇹🇯 + 992",
  },
  {
    name: "Tanzania",
    value: "tz",
    countryCode: "255",
    text: "🇹🇿 + 255",
  },
  {
    name: "Thailand (ไทย)",
    value: "th",
    countryCode: "66",
    text: "🇹🇭 + 66",
  },
  {
    value: "tl",
    name: "Timor-Leste",
    countryCode: "670",
    text: "🇹🇱 + 670",
  },
  {
    name: "Togo",
    value: "tg",
    countryCode: "228",
    text: "🇹🇬 + 228",
  },
  {
    name: "Tokelau",
    value: "tk",
    countryCode: "690",
    text: "🇹🇰 + 690",
  },
  {
    name: "Tonga",
    value: "to",
    countryCode: "676",
    text: "🇹🇴 + 676",
  },
  {
    name: "Trinidad and Tobago",
    countryCode: "1868",
    value: "tt",
    text: "🇹🇹 + 1868",
  },
  {
    name: "Tunisia (‫تونس‬‎)",
    value: "tn",
    countryCode: "216",
    text: "🇹🇳  + 216",
  },
  {
    name: "Turkey (Türkiye)",
    value: "tr",
    countryCode: "90",
    text: "🇹🇷 + 90",
  },
  {
    name: "Turkmenistan",
    value: "tm",
    countryCode: "993",
    text: "🇹🇲 + 993",
  },
  {
    name: "Turks and Caicos Islands",
    value: "tc",
    countryCode: "1649",
    text: "🇹🇨 + 1649",
  },
  {
    name: "Tuvalu",
    value: "tv",
    countryCode: "688",
    text: "🇹🇻 + 688",
  },
  {
    name: "Uganda",
    value: "ug",
    countryCode: "256",
    text: "🇺🇬 + 256",
  },
  {
    name: "Ukraine (Україна)",
    countryCode: "380",
    value: "ua",
    text: "🇺🇦 + 380",
  },
  {
    name: "United Arab Emirates (‫الإمارات العربية المتحدة‬‎)",
    countryCode: "971",
    value: "ae",
    text: "🇦🇪 + 971",
  },
  {
    name: "United Kingdom",
    value: "gb",
    countryCode: "44",
    text: "🇬🇧 + 44",
  },
  {
    name: "Uruguay",
    countryCode: "598",
    value: "uy",
    text: "🇺🇾 + 598",
  },
  {
    name: "U.S. Virgin Islands",
    countryCode: "1340",
    value: "vi",
    text: "🇻🇮 + 1340",
  },
  {
    name: "Uzbekistan (Oʻzbekiston)",
    countryCode: "998",
    value: "uz",
    text: "🇺🇿 + 998",
  },
  {
    name: "Vanuatu",
    countryCode: "678",
    value: "vu",
    text: "🇻🇺 + 678",
  },
  {
    name: "Vatican City (Città del Vaticano)",
    countryCode: "39",
    value: "va",
    text: "🇻🇦 + 39",
  },
  {
    name: "Venezuela",
    countryCode: "58",
    value: "ve",
    text: "🇻🇪 + 58",
  },
  {
    name: "Vietnam (Việt Nam)",
    countryCode: "84",
    value: "vn",
    text: "🇻🇳 + 84",
  },
  {
    name: "Wallis and Futuna",
    countryCode: "681",
    value: "wf",
    text: "🇼🇫 + 681",
  },
  {
    name: "Western Sahara (‫الصحراء الغربية‬‎)",
    value: "eh",
    text: "🇪🇭 + 212",
    countryCode: "212",
  },
  {
    name: "Yemen (‫اليمن‬‎)",
    value: "ye",
    countryCode: "967",
    text: "🇾🇪 + 967",
  },
  {
    name: "Zambia",
    value: "zm",
    countryCode: "260",
    text: "🇿🇲 + 260",
  },
  {
    name: "Zimbabwe",
    countryCode: "263",
    value: "zw",
    text: "🇿🇼 + 263",
  },
]

export const countries: CountryData[] = COUNTRIES.sort(
  (a, b) =>
    Math.floor(Math.log10(Math.abs(Number(a.countryCode)))) -
      Math.floor(Math.log10(Math.abs(Number(b.countryCode)))) ||
    Number(a.countryCode) - Number(b.countryCode)
)
